import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SearchPage from "@/pages/SearchPage";
import TunePage from "@/pages/TunePage";
import FavouritesPage from "@/pages/FavouritesPage";
import PrivacyPage from "@/pages/PrivacyPage";
import AboutPage from "@/pages/AboutPage";
import SignInLanding from "@/pages/SignInLanding";
import AdminPage from "@/pages/AdminPage";
import SocialStudioPage from "@/pages/SocialStudioPage";
import AuthCallback from "@/components/AuthCallback";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import { AuthProvider } from "@/contexts/AuthContext";

function AppRouter() {
  const location = useLocation();
  // Process the OAuth fragment first (prevents race conditions with /auth/me).
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<SearchPage />} />
      <Route path="/tune/:id" element={<TunePage />} />
      <Route path="/favourites" element={<FavouritesPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/admin/social" element={<SocialStudioPage />} />
      <Route path="/signin" element={<SignInLanding />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
